import { useQuery } from "react-query";
import { GET } from "../../../../Services";

export const useImagenesPokemon = (id) => {
  return useQuery(
    ["imagenesPokemon", id],
    async () => {
      if (!id) return null;
      const response = await GET("pokemon/imagenesPokemon", `?idPokemon=${id}`);
      return response;
    },
    { enabled: !!id }
  );
};
